import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { UcrSecurityService } from '../core/ucr-security/ucr-security.service';
import { Roles } from '../core/ucr-security/roles';
import { UserInfo } from '../core/ucr-security/user-info';

@Injectable()
export class MainMenuAuthGuardService {
    readonly roles = Roles;

    constructor(private ucrSecurity: UcrSecurityService, private router: Router) {
        //
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.ucrSecurity.getUserInfo().pipe(
            map((ui: UserInfo) => {
                // todo: update access rules
                // return true;

                // if (!this.ucrSecurity.isLoggedIn) {
                //     this.ucrSecurity.login();
                //     return false;
                // }

                if (ui.ifAnyGranted([this.roles.instructor, this.roles.departmentAdministrator,  this.roles.registrarStaff,  this.roles.registrarAdmin])) {
                    return true;
                } else {
                    this.router.navigate(['/notAuthorized']);
                    return false;
                }
            })
        );
    }
}
